import styled from "styled-components";

interface LineProps {
  height?: string;
}

export const VerticalLine = styled.div<LineProps>`
  background-color: #a2a0874d;
  height: ${({ height }) => height || "100px"};
  width: 2px;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
